import React, { useEffect, useState } from "react";
import { changeStatusCenter, deleteCenter, getCenters } from "../../../../api/center";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Table, { buttonsStyle } from "../../../components/tables/table";
import { Button, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import DeleteIcon from "@material-ui/icons/Delete";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

export default function CenterPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);
    const [centers, setCenters] = useState([]);
    const [center, setCenter] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        setRefresh(false);
    }, [refresh])

    useEffect(() => {
        fetch();
    }, [])

    function fetch() {
        getCenters()
            .then((res) => {
                setCenters(res.data);
            })
            .catch((error) => {
                if (error.request.status !== 404) {
                    alertError({
                        error,
                        customMessage: "No se han encontrado centros."
                    })
                }
            })
    }

    const columns = [
        { dataField: "fullName", text: "Nombre", sort: true },
        { dataField: "address", text: "Dirección", sort: true },
        { dataField: "city", text: "Ciudad", formatter: localityFormatter, sort: true },
        { dataField: "province", text: "Provincia", formatter: localityFormatter, sort: true },
        {
            dataField: "_id",
            text: "",
            formatter: buttonFormatter,
            align: 'right',
            headerStyle: { width: '200px' }
        },
    ];

    function localityFormatter(cell) {
        return cell?.fullName;
    }

    function buttonFormatter(cell) {
        const elem = centers.find((item) => item._id === cell);

        return (
        <>
            <Tooltip title="Edit">
            <Button
                style={buttonsStyle}
                size="small"
                onClick={() => history.push("/edit-center/" + elem._id)}
            >
                <EditIcon />
            </Button>
            </Tooltip>
            {user?.isAdmin && (
            <>
                <Tooltip title={elem?.active ? "Desactivar" : "Activar"}>
                <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                        setCenter(elem);
                        setOpenConfirmDialog(1);
                    }}
                >
                    {elem?.active ? (
                    <ToggleOffIcon />
                    ) : (
                    <ToggleOnIcon style={{ color: "red" }} />
                    )}
                </Button>
                </Tooltip>
                <Tooltip title="Delete">
                <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                        setCenter(elem);
                        setOpenConfirmDialog(2);
                    }}
                >
                    <DeleteIcon />
                </Button>
                </Tooltip>
            </>
            )}
        </>
        );
    }

    return  (
        <Card>
            <CardHeader title="Centros">
                <CardHeaderToolbar>
                <button
                    type="button"
                    className="btn btn-primary text-white"
                    onClick={() => history.push("/edit-center")}
                >
                    Añadir
                </button>
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                { !refresh && (
                    <Table data={centers} columns={columns} />
                )}
            </CardBody>
            <ConfirmDialog
                title={`Seguro que quieres ${center?.active ? 'deshabilitar' : 'habilitar'} el centro?`}
                open={openConfirmDialog === 1}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    changeStatusCenter(center._id, !center?.active)
                        .then((res) => {
                            if (res.status === 200) {
                                alertSuccess({ title: `${center?.active ? 'Deshabilitado!' : 'Habilitado!'}`, customMessage: `Centro ${center?.active ? 'deshabilitado' : 'habilitado'} correctamente` })
                                fetch();
                                setRefresh(true);
                            }
                        })
                        .catch((error) => {
                            alertError({ error: error, customMessage: `No se ha podido ${center?.active ? 'deshabilitar' : 'habilitar'} centro.` })
                        });
                }}
            />
            <ConfirmDialog
                title={'Seguro que quieres eliminar este centro?'}
                open={openConfirmDialog === 2}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    deleteCenter(center?._id)
                        .then((res) => {
                            if (res.status === 204 || res.status === 200) {
                                alertSuccess({
                                    title: 'Eliminado!',
                                    customMessage: 'Center eliminado correctamente.',
                                });
                                fetch();
                                setRefresh(true);
                            }
                        })
                        .catch((error) => {
                            alertError({
                                error: error,
                                customMessage: 'No se ha podido eliminar el centro.',
                            });
                        });
                }}
            />
        </Card>
    )
} 